// src/observability/init.ts — ai2aim-web wiring for the error reporter.
// This app is largely anonymous; userId is attached only when a session exists.
import { initErrorReporter } from './errorReporter';
import { store } from '../app/store';

function readEnv(key: string): string {
    const value = (import.meta.env as Record<string, string | undefined>)[key];
    return typeof value === 'string' ? value : '';
}

export function initObservability(): void {
    const ingestUrl = readEnv('VITE_OBS_INGEST_URL');
    const ingestKey = readEnv('VITE_OBS_INGEST_KEY');
    const environment = readEnv('VITE_OBS_ENV');
    initErrorReporter({
        ingestUrl,
        ingestKey,
        project: 'ai2aim-web',
        release: readEnv('VITE_APP_VERSION') || 'unknown',
        environment: environment || 'unknown',
        enabled: Boolean(ingestUrl && ingestKey && environment),
        getContext: () => {
            const auth = store.getState().auth;
            return {
                userId: auth.user?.id ?? null,
                organizationId: null,
            };
        },
    });
}
